import { ModuleConfig, ModuleFields } from "~/Utils/drilldownData";

export const getHomepageBannerDrillDownData: { [key in ModuleConfig]: ModuleFields[] } = {
  homePageBanner: [
    {
        fieldName: "Order Sequence",
        fieldValue: "field_banner_sequence",
        className: "col-span-6",
        type: "text",
        name: "field_banner_sequence",
        formType: "number",
        label: "Order Sequence",
        placeholder: "Enter Order Sequence",
        validation: { required: "Order Sequence is required" },
    },
    {
      fieldName: "Image",
      fieldValue: "field_banner_image",
      className: "col-span-6",
      type: "image",
      name: "field_banner_image",
      formType: "file",
      usedFileType: 'image/*',
      label: "Image",
      placeholder: "Select Image",
      validation: { required: "Image is required" },
    },
    {
      fieldName: "Title",
      fieldValue: "title",
      className: "col-span-6",
      type: "text",
      name: "title",
      formType: "input",
      label: "Homepage Banner Title",
      placeholder: "Homepage Banner Title",
      validation: { required: "Homepage Banner Title is required" },
    },
    {
      fieldName: "Banner url",
      fieldValue: "field_banner_url_en",
      className: "col-span-6",
      type: "text",
      name: "field_banner_url_en",
      formType: "input",
      label: "Banner url",
      placeholder: "Enter Banner url",
      validation: { validate: (value: any): true | string => {
  if (!value || value === "" || typeof value !== "string") {
    return true;
  }
  const url = value.trim();
  const isInternal = url.startsWith("/");
  const isExternal = /^https?:\/\//i.test(url) || /^www\./i.test(url);
  return isInternal || isExternal ? true : "Please enter a valid URL (start with / or https://, http://, www.)";
}},
    },
    // {
    //   fieldName: "Banner url (MS)",
    //   fieldValue: "field_banner_url_ms",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_banner_url_ms",
    //   formType: "input",
    //   label: "Banner url (MS)",
    //   placeholder: "Enter Banner url (EN)",
    //   // validation: { required: "Title (EN) is required" },
    // },
    // {
    //   fieldName: "Banner url (ZH)",
    //   fieldValue: "field_banner_url_zh",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_banner_url_zh",
    //   formType: "input",
    //   label: "Banner url (ZH)",
    //   placeholder: "Enter Banner url (ZH)",
    //   // validation: { required: "Banner url (ZH) is required" },
    // },
    {
      fieldName: "Published",
      fieldValue: "published",
      className: "col-span-12",
      type: "checkbox",
      name: "published",
      formType: "checkbox",
      label: "Published",
      placeholder: "Enter Published",
      // validation: { required: "Publish is required" },
    }
  ],
};
